var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"telButton",attrs:{"href":("mailto:" + (_vm.$route.params.mailto))}})}
var staticRenderFns = []

export { render, staticRenderFns }